import React, { Component } from "react"
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as _ from "lodash";
import PropTypes from "prop-types";
import i18n from "../../i18n";
import * as rk from "../../localization/resourceKeys";
import BottomLine from "../Footer/BottomLine";
import "./rightToCorrect.css";
import UpdateName from "./updateName";
import UpdateEmail from "./updateEmail";
import UpdatePhoneNumber from "./updatePhoneNumber";
import UpdateAddress from "./updateAddress";
import BannerNotification from "../../banner/bannerNotification";
import { getExperianDetails } from "../../redux/ExperianForm/experianAction";
import { getProtectionServicesExperianDetails } from "../../redux/ProtectionServicesExperianForm/protectionServicesExperianAction";

class RightToCorrectContainer extends Component {
  constructor(props) {
    super(props);
    if (!props?.selectedRequest) {
      window.location.replace("/");
    }
  }

  handleButtonDisable = () => {
    return !(this.props.correctedState.isCorrectedName || this.props.correctedState.isCorrectedEmail || this.props.correctedState.isCorrectedPhoneNumber || this.props.correctedState.isCorrectedAddress);
  }

  routeOnSubmit = () => {
    this.props.history.push("/formComplete", { isDataCorrectionFormComplete: true });
  }

  handleSubmit = (submitPrivacyRequestPayload) => {
    const requester = submitPrivacyRequestPayload?.requester || "";
    const experianPayload = {
      firstName: requester?.firstName,
      middleName: requester?.middleInitial,
      lastName: requester?.lastName,
      addressLine1: requester?.addresses?.[0].addressLine1,
      addressLine2: requester?.addresses?.[0].addressLine2,
      city: requester?.addresses?.[0].city,
      stateOrProvince: requester?.addresses?.[0].stateOrProvince,
      postalCode: requester?.addresses?.[0].postalCode,
      postalCodeExtension: "",
      dateOfBirth: requester?.dateOfBirth,
      fullSsn: requester?.fullSsn,
      telephoneNumber: requester?.phone,
    }

    this.props.brandAffiliation === i18n.t(rk.BRANDS_OPTION_VWD_APP_DER) ? 
    this.props.getProtectionServicesExperianDetails(experianPayload, this.props.history, submitPrivacyRequestPayload) :
    this.props.getExperianDetails(experianPayload, this.props.history, submitPrivacyRequestPayload);
  }

  render() {
    const { t, currentStateResidence } = this.props;
    const submitPrivacyRequestPayload = this.props.location.state ? this.props.location.state.submitPrivacyRequestPayload : "";
    const isVA = currentStateResidence === i18n.t(rk.STATE_VIRGINIA);
    const isCO = currentStateResidence === i18n.t(rk.STATE_COLORADO);
    const isCT = currentStateResidence === i18n.t(rk.STATE_CONNECTICUT);
    const showBottomText = !isVA && !isCT && !isCO;
    return (
      <>
        {!_.isEmpty(this.props.networkError) && (
          <BannerNotification notificationStyle="error">
            {t(rk.ERROR_API_FAIL)}
          </BannerNotification>
        )}
        <div className="u-m-none">
          <div className="u-mb-large right-to-correct-info">
            {t(rk.DATA_CORRECTION.INFO)}
          </div>
        </div>
        <div className="right-to-correct-table-container">
          <UpdateName />
          <UpdateEmail />
          <UpdatePhoneNumber />
          <UpdateAddress />
        </div>
        <div className="u-mt-xlarge">
          <div>{t(rk.DATA_CORRECTION.VWGOA_SUBMIT_COPY)}</div>
          <div className="u-m-none u-mt-small">
            <button
              data-testid="right-to-correct-form-btn"
              id="right-to-correct-form-btn"
              className="c-btn u-block u-block-center"
              onClick={async () => {
                submitPrivacyRequestPayload.incorrectData = {
                  firstName: this.props.correctedState.firstName || "",
                  middleName: this.props.correctedState.middleInitial || "",
                  lastName: this.props.correctedState.lastName || "",
                  dateOfBirth: "",
                  phone: this.props.correctedState.phone || "",
                  emailAddress: this.props.correctedState.emailAddress || "",
                  addressLine1: this.props.correctedState.addressLine1 || "",
                  addressLine2: this.props.correctedState.addressLine2 || "",
                  city: this.props.correctedState.city || "",
                  stateOrProvince: this.props.correctedState.state || "",
                  postalCode: this.props.correctedState.postalCode || "",
                  postalCodeExtension: "",
                  country: "",
                };
                this.handleSubmit(submitPrivacyRequestPayload);
              }}
              disabled={this.handleButtonDisable()}
            >
              <span className="c-btn__text">{i18n.t(rk.BUTTON.SUBMIT)}</span>
            </button>
          </div>
        </div>

        <div className="right-to-correct-footer-wrapper">
          <div id="request-footer-content" className="request-footer-content-2">
            {showBottomText && (
              <div id="right-to-correct-footer-text">
                <p className="intructions-title u-mb-xxsmall u-font-size-fs0">
                  {t(rk.DATA_CORRECTION.BOTTOM_TEXT1)}
                </p>
                <ul className="o-list-casual u-m-xxsmall@xs">
                  <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                    {t(rk.DATA_CORRECTION.BOTTOM_TEXT2)}
                  </li>
                  <li className="u-mb-none u-pl-xsmall u-ml-xsmall u-font-size-fs0">
                    {t(rk.DATA_CORRECTION.BOTTOM_TEXT3)}
                  </li>
                </ul>
              </div>
            )}
            <BottomLine />
          </div>
        </div>
      </>
    );
  }
}

RightToCorrectContainer.propTypes = {
  t: PropTypes.func.isRequired,
  getExperianDetails: PropTypes.func.isRequired,
  getProtectionServicesExperianDetails: PropTypes.func.isRequired,
  networkError: PropTypes.string,
  correctedState: PropTypes.object,
  selectedRequest: PropTypes.object,
  currentStateResidence: PropTypes.string,
  brandAffiliation: PropTypes.string,
  history: PropTypes.object,
  location: PropTypes.object,
};

const mapStateToProps = (state) => ({
  networkError: state.networkError,
  correctedState: state.rightToCorrectReducer,
  selectedRequest: state.requestSelector.selectedRequest,
  currentStateResidence: state.stateSelector.currentStateResidence,
  brandAffiliation: state.stateSelector.brandAffiliation,
});

const mapDispatchToProps = (dispatch) => ({
  getExperianDetails: (action, routeProps, submitPrivacyRequestPayload) =>
    dispatch(
      getExperianDetails(action, routeProps, submitPrivacyRequestPayload)
    ),
  getProtectionServicesExperianDetails: (
    action,
    routeProps,
    submitPrivacyRequestPayload
  ) =>
    dispatch(
      getProtectionServicesExperianDetails(
        action,
        routeProps,
        submitPrivacyRequestPayload
      ),
    ),
});

export default connect(
  mapStateToProps, mapDispatchToProps
)(withTranslation()(RightToCorrectContainer));
